// extracted by mini-css-extract-plugin
export default {"container":"DnWha","block":"ONFf2","emptySection":"Bn1iv","sectionTitle":"YjBlH","label":"ap7yC","value":"wSytI","input":"yEa0G","section":"T5TLN","buttons":"kDnK3"};